import React from 'react';
import WordCard from '../course/WordCard';
import SentenceCard from '../course/SentenceCard';

// This is a simple wrapper to hold the grid layout classes, avoiding repetition.
const Grid = ({ contentType, children }) => {
  const gridClasses =
    contentType === 'words'
      ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6'
      : 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3';

  return <div className={`grid gap-1 sm:gap-4 pt-2 ${gridClasses}`}>{children}</div>;
};

/**
 * A generic grid for rendering items (words or sentences).
 * It accepts item data and callbacks, and passes them down to the appropriate card.
 * Any extra props are passed down using the ...rest operator.
 */
const ItemGrid = ({ items, contentType, onCardClick, isSelectedCheck, learnedIds, ...rest }) => {
  return (
    <Grid contentType={contentType}>
      {items.map((item) => (
        <div key={item.id} className="p-0.5 sm:p-1">
          {contentType === 'words' ? (
            <WordCard
              word={item}
              onCardClick={() => onCardClick(item)}
              isSelected={isSelectedCheck ? isSelectedCheck(item.id) : false}
              learnedIds={learnedIds}
              {...rest}
            />
          ) : (
            <SentenceCard
              sentence={item}
              onCardClick={() => onCardClick(item)}
              learnedIds={learnedIds}
              {...rest}
            />
          )}
        </div>
      ))}
    </Grid>
  );
};

export default ItemGrid;
